import { render, staticRenderFns } from "./TabsHeaderMobile.vue?vue&type=template&id=66f58d0b&"
import script from "./TabsHeaderMobile.vue?vue&type=script&lang=js&"
export * from "./TabsHeaderMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports